/**
 * This enum has predefined instance identifiers for bookmarks.
 * This is used in case you have bookmark inside a component.
 * This component can exist on multiple pages - meaning on multiple routes as well.
 * If you had same ids for bookmark - it would be confused on where to apply the bookmark.
 * It's safe to assume that page is going to have less than 100 original bookmarks, so we start from 100.
 * TL;DR - this is to avoid situations when we have bookmarks with the same ids on page that uses components that have bookmarks.
 * TL;DR - To avoid both page or a couple of components having id 0 for example, the calculated hash in this case would be the same and we don't want that.
 */
export enum BookmarkPredefinedInstanceIdentifier {
	ReplenishmentTable = 100,
}
